module.exports = __webpack_public_path__ + "img/send-chat.25b739c3.svg";